import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function IngredientsSection() {
  return <section className="my-12 space-y-10" data-id="element-34">
      {/* Step 1 */}
      <div className="bg-[#F4F4F0] border border-stone-200 p-6 sm:p-8 rounded-sm" data-id="element-35">
        <h4 className="text-center font-bold text-stone-900 tracking-widest text-sm mb-8 uppercase" data-id="element-36">
          — STEP 1: THE CLEARING PROCESS —
        </h4>

        <div className="space-y-6" data-id="element-37">
          <div className="flex gap-4" data-id="element-38">
            <CheckCircle2 className="text-[#2D6A4F] shrink-0 mt-1" size={24} data-id="element-39" />
            <p className="text-lg leading-relaxed text-stone-800" data-id="element-40">
              <strong data-id="element-41">Microcrystalline Hydroxyapatite</strong> — Forms a
              protective shield to repel bad bacteria with the exact mineral
              your teeth are made of by bonding directly to enamel, filling
              micro-cracks, and rebuilding what years of acid erosion destroyed.
            </p>
          </div>
          <p className="text-lg leading-relaxed text-stone-800 pl-10" data-id="element-42">
            This is the foundation everything else depends on. Without this
            step, nothing that follows can work…
          </p>
        </div>
      </div>

      {/* Step 2 */}
      <div className="bg-[#F4F4F0] border border-stone-200 p-6 sm:p-8 rounded-sm" data-id="element-43">
        <h4 className="text-center font-bold text-stone-900 tracking-widest text-sm mb-8 uppercase" data-id="element-44">
          — STEP 2: THE GUARD —
        </h4>

        <div className="space-y-6" data-id="element-45">
          <div className="flex gap-4" data-id="element-46">
            <CheckCircle2 className="text-[#2D6A4F] shrink-0 mt-1" size={24} data-id="element-47" />
            <p className="text-lg leading-relaxed text-stone-800" data-id="element-48">
              <strong data-id="element-49">Lactobacillus Salivarius</strong> — Jams the communication
              signals bad bacteria use to build and organize behind biofilm –
              the bacterial fortress that's been shielding harmful bacteria from
              everything you've tried.
            </p>
          </div>

          <div className="flex gap-4" data-id="element-50">
            <CheckCircle2 className="text-[#2D6A4F] shrink-0 mt-1" size={24} data-id="element-51" />
            <p className="text-lg leading-relaxed text-stone-800" data-id="element-52">
              <strong data-id="element-53">Lactobacillus Paracasei</strong> — Colonizes your mouth
              and crowds out cavity-causing bacteria for up to four weeks.
              Clinical studies show 4.5x fewer new cavities in just 6 months.
            </p>
          </div>

          <div className="flex gap-4" data-id="element-54">
            <CheckCircle2 className="text-[#2D6A4F] shrink-0 mt-1" size={24} data-id="element-55" />
            <p className="text-lg leading-relaxed text-stone-800" data-id="element-56">
              <strong data-id="element-57">Lactobacillus Acidophilus</strong> — Makes your enamel
              surface inhospitable for harmful bacteria trying to reanchor.
              Without any grip, bad bacteria simply slides off.
            </p>
          </div>

          <p className="text-lg leading-relaxed text-stone-800 pl-10 py-2" data-id="element-58">
            Now that the enamel is rebuilt and the biological guard is restored
            — I added two more compounds specifically to make both steps work
            even harder.
          </p>

          <div className="flex gap-4" data-id="element-59">
            <CheckCircle2 className="text-[#2D6A4F] shrink-0 mt-1" size={24} data-id="element-60" />
            <p className="text-lg leading-relaxed text-stone-800" data-id="element-61">
              <strong data-id="element-62">Xylitol</strong> — Starves hidden bacteria from the inside
              out while raising oral pH to the exact range where hydroxyapatite
              remineralizes enamel best.
            </p>
          </div>

          <div className="flex gap-4" data-id="element-63">
            <CheckCircle2 className="text-[#2D6A4F] shrink-0 mt-1" size={24} data-id="element-64" />
            <p className="text-lg leading-relaxed text-stone-800" data-id="element-65">
              <strong data-id="element-66">Guava Leaf Extract</strong> — Outperforms
              prescription-strength antibacterial rinses by nearly 20% — without
              killing a single healthy bacterium.
            </p>
          </div>
        </div>
      </div>
    </section>;
}